module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Claims Dashboard",
      "set-position": "fixed",
      "create-button": true,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-your-claims",
    attrs: {
      "id": "app"
    }
  }, [_c('claims-dashboard-icons'), _vm._v(" "), _c('claim-table', {
    ref: "claims",
    attrs: {
      "show-delete": ""
    },
    on: {
      "select": _vm.loadClaimAndView,
      "delete": _vm.deleteClaim
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "confirm_delete",
      "no-default-button": true
    }
  }, [_c('div', [_c('h1', [_vm._v("Are you sure you want to delete this claim?")]), _vm._v(" "), _c('p', [_vm._v("Once you delete this claim you can not get it back, are you sure?")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    staticStyle: {
      "background": "red"
    },
    on: {
      "click": _vm.performDelete
    }
  }, [_vm._v("\n                Delete\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.dismissClose
    }
  }, [_vm._v("\n                Close\n            ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31d1fd9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims-dashboard/ClaimsDashboard.vue
// module id = 1632
// module chunks = 0